import React, { lazy } from "react";
import { defer } from "react-router-dom";
import RouteLoader from "../UI/RouteLoader";
import { getSchoolRequest } from "../../requests/schools";
import { withSuspense } from "./routeHelpers";

const Schools = lazy(
  () => import(/* webpackChunkName: "schools" */ "../Schools/Schools")
);
const School = lazy(
  () => import(/* webpackChunkName: "schools" */ "../Schools/School/School")
);
const SchoolOverview = lazy(
  () =>
    import(
      /* webpackChunkName: "schools" */ "../Schools/School/SchoolOverview/SchoolOverview"
    )
);
const SchoolInstructors = lazy(
  () =>
    import(
      /* webpackChunkName: "schools" */ "../Schools/School/SchoolInstructors/SchoolInstructors"
    )
);
const SchoolCourses = lazy(
  () =>
    import(
      /* webpackChunkName: "schools" */ "../Schools/School/SchoolCourses/SchoolCourses"
    )
);
const SchoolSeminars = lazy(
  () =>
    import(
      /* webpackChunkName: "schools" */ "../Schools/School/SchoolSeminars/SchoolSeminars"
    )
);
const SchoolNew = lazy(
  () => import(/* webpackChunkName: "schools" */ "../Schools/School/SchoolNew")
);
const SchoolStudents = lazy(
  () =>
    import(
      /* webpackChunkName: "schools" */ "../Schools/School/SchoolStudents/SchoolStudents"
    )
);

export default [
  {
    path: "/schools",
    element: withSuspense(Schools),
  },
  {
    path: "/schools/new",
    element: withSuspense(SchoolNew),
  },
  {
    path: "/schools/:schoolId",
    element: (
      <RouteLoader>
        {(loader) => withSuspense(<School school={loader?.data} />)}
      </RouteLoader>
    ),
    id: "school",
    loader: ({ params }) => {
      return defer({
        data: getSchoolRequest({ schoolId: params.schoolId }),
      });
    },
    children: [
      {
        path: "/schools/:schoolId/overview",
        element: withSuspense(SchoolOverview),
      },
      {
        path: "/schools/:schoolId/instructors",
        element: withSuspense(SchoolInstructors),
      },
      {
        path: "/schools/:schoolId/courses",
        element: withSuspense(SchoolCourses),
      },
      {
        path: "/schools/:schoolId/seminars",
        element: withSuspense(SchoolSeminars),
      },
      {
        path: "/schools/:schoolId/students",
        element: withSuspense(SchoolStudents),
      },
    ],
  },
];
